import { Grid2 } from '@mui/material';
import React from 'react';
import { CompetitionNavBtn } from '../CompetitionNavBtn/CompetitionNavBtn';
import { GeneralNavBtn } from '../GeneralNavBtn/GeneralNavBtn';
import { TrainingNavBtn } from '../TrainingNavBtn/TrainingNavBtn';
import { useSlidesData } from '../GameModesCarousel/useSlidesData';
import map from 'lodash/map';
import AttemptsWidget from '../../AttemptsWidget/AttemptsWidget';
import TypographyWithShadow from '../../Typography/TypographyWithShadow';
import { Illustration } from '../../Illustration';
import { Icon } from '../../Icon';
import { materialStyles } from './styles';
import { useTranslation } from 'react-i18next';

const GameModesDesktop: React.FC = () => {
  const slidesData = useSlidesData();
  const getPlayGameBtn = (index: number) => {
    switch (index) {
      case 0:
        return <CompetitionNavBtn />;
      case 1:
        return <GeneralNavBtn />;
      case 2:
        return <TrainingNavBtn />;
      default:
        return null;
    }
  };
  const { t } = useTranslation();

  return (
    <Grid2 sx={materialStyles.container}>
      {map(slidesData, (slide, index) => {
        const isTraining = slide.id === 'training';
        const isGeneral = slide.id === 'general';
        const slideStyles = isGeneral
          ? [materialStyles.slide, materialStyles.generalModeComingSoonSlide]
          : materialStyles.slide;

        return (
          <Grid2 key={index} sx={materialStyles.sliderContainer}>
            <Grid2 sx={materialStyles.sliderContainerInner}>
              <Grid2 sx={slideStyles}>
                <Grid2
                  sx={
                    isTraining
                      ? materialStyles.attemptsTrainingContainer
                      : materialStyles.attemptsContainer
                  }
                >
                  {slide.attempts != null && slide.totalAttempts != null && (
                    <AttemptsWidget
                      // TODO: commented code is made for unlimited attempts in Training mode. It can be useful in case of new payed features
                      // isTraining={isTraining}
                      attempts={slide.attempts}
                      totalAttempts={slide.totalAttempts}
                    />
                  )}
                </Grid2>
                {slide.score != null && slide.score !== '' && (
                  <Grid2 sx={materialStyles.scoreContainer}>
                    {/* TODO: probably better to make component for ScoreWhiteIcon  */}
                    <Icon
                      sx={materialStyles.scoreIcon}
                      iconName="ScoreWhiteIcon"
                    />
                    <TypographyWithShadow
                      shadowType="DARK"
                      sx={materialStyles.scoreText}
                    >
                      {slide.score}
                    </TypographyWithShadow>
                  </Grid2>
                )}

                <Illustration
                  sx={materialStyles.backgroundIllustration}
                  illustrationName={slide.bgImg}
                />

                <Grid2 sx={materialStyles.bottomContainer}>
                  <TypographyWithShadow
                    sx={materialStyles.title}
                    shadowType="DARK"
                  >
                    {slide.title}
                  </TypographyWithShadow>
                  <TypographyWithShadow
                    sx={materialStyles.text}
                    shadowType="DARK"
                  >
                    {slide.text}
                  </TypographyWithShadow>
                </Grid2>
              </Grid2>
              {isGeneral && (
                <Grid2 sx={materialStyles.generalModeDisabledContainer}>
                  <TypographyWithShadow
                    shadowType="DARK"
                    sx={materialStyles.comingSoonText}
                  >
                    {t('game.coming_soon')}
                  </TypographyWithShadow>
                </Grid2>
              )}
            </Grid2>

            <Grid2>{getPlayGameBtn(index)}</Grid2>
          </Grid2>
        );
      })}
    </Grid2>
  );
};

export default GameModesDesktop;
